import template from './utilities-terms-input.jade';

export default angular
  .module('cian.addForm.bargainTermsUtilitiesTerms')
  .directive('cianAfPriceAndDealTermsUtilitiesTermsInput', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService, popupService) {
      'ngInject';

      if (typeof this.ad.bargainTerms.utilitiesTerms.flowMetersNotIncludedInPrice !== 'boolean') {
        this.ad.bargainTerms.utilitiesTerms.flowMetersNotIncludedInPrice = true;
      }

      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Коммунальные платежи';
      this.tooltipText = `
        Мы покажем размер коммунальных платежей на странице вашего
        объявления и избавим вас от лишних вопросов по телефону.<br/><br/>
        Если вы не знаете точный размер, укажите примерный.
        Если коммунальные услуги зависят от сезона, укажите среднюю стоимость за месяц.
        Это поможет арендатору оценить свои финансовые возможности.<br/><br/>
        При сортировке объявлений учитывается только размер арендной платы,
        коммунальные услуги не прибавляются к стоимости аренды.
      `;
      this.hintText = this.tooltipText;

      this.openTooltipModal = () => {
        popupService.openPopup('hint', {
          text: this.hintText,
          title: this.modalHintTitle,
          hideCloseButton: false,
        });
      };

      this.isPriceEntered = () => {
        return !!this.ad.bargainTerms.utilitiesTerms.price;
      };
    },
    controllerAs: 'utilitiesTermsInputCtrl',
    template,
  })).name;
